/**
 * 인증 파사드 — 모드(config/mode.ts)에 따라 로컬 세션 또는 QBase 세션을 쓴다.
 * authSlice 는 이 파일만 import 한다(시그니처 동일).
 */
import { IS_LOCAL } from '../config/mode';
import * as localImpl from './localAuthClient';
import * as qbaseImpl from './qbaseClient';

const impl: any = IS_LOCAL ? localImpl : qbaseImpl;

export const DEVICE_ID = impl.DEVICE_ID;
export const getSession = impl.getSession;
export const login = impl.login;
export const logout = impl.logout;
export const acquireEdit = impl.acquireEdit;
export const ensureActiveSystem = impl.ensureActiveSystem;
export const QbaseError = impl.QbaseError;
/** 체험 계정 바로 로그인 — QBase(웹) 판에만 있다. 스탠드얼론은 리본이 뜨지 않으므로 부를 일이 없다 */
export const trialLogin = (loginId: string): Promise<{ viewOnly: boolean }> => {
  if (IS_LOCAL) return Promise.reject(new Error('trial login is not available in standalone mode'));
  return qbaseImpl.trialLogin(loginId);
};

export type { AuthSession } from './authTypes';
/** 예전 이름 호환 — authSlice 가 qbase.QbaseSession 으로 참조한다 */
export type { AuthSession as QbaseSession } from './authTypes';
